import { useState, useEffect } from 'react';
import "./index.css";

// Components
import { Navigation } from './components/Navigation/Navigation';
import { Hero } from './components/Hero/Hero';
import { About } from './components/About/About';
import { Skills } from './components/Skills/Skills';
import { Experience } from './components/Experience/Experience';
import { Projects } from './components/Projects/Projects';
import { Contact } from './components/Contact/Contact';
import { Footer } from './components/Footer/Footer';

// Configuration
import { defaultCVConfig } from './config/cvConfig';

export function App() {
  const [activeSection, setActiveSection] = useState('hero');
  const config = defaultCVConfig;

  useEffect(() => {
    // Scroll spy functionality
    const handleScroll = () => {
      const sections = config.layout.sections;
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetHeight = element.offsetHeight;

          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    if (config.layout.enableScrollSpy) {
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, [config.layout.enableScrollSpy, config.layout.sections]);

  const handleSectionClick = (section: string) => {
    const element = document.getElementById(section);
    if (element) {
      element.scrollIntoView({ 
        behavior: config.layout.enableSmoothScroll ? 'smooth' : 'auto' 
      });
    }
  };

  return (
    <div className="min-h-screen">
      {/* Navigation */}
      {config.layout.showNavigation && (
        <Navigation
          sections={config.layout.sections}
          activeSection={activeSection}
          onSectionClick={handleSectionClick}
        />
      )}

      {/* Main Content */}
      <main>
        {/* Hero Section */}
        {config.layout.sections.includes('hero') && (
          <Hero 
            config={config.personal} 
            theme={config.theme}
          />
        )}

        {/* About Section */}
        {config.layout.sections.includes('about') && (
          <About personal={config.personal} />
        )}

        {/* Skills Section */}
        {config.layout.sections.includes('skills') && (
          <Skills skills={config.skills} />
        )}

        {/* Experience Section */}
        {config.layout.sections.includes('experience') && (
          <Experience experience={config.experience} />
        )}

        {/* Projects Section */}
        {config.layout.sections.includes('projects') && (
          <Projects projects={config.projects} />
        )}

        {/* Contact Section */}
        {config.layout.sections.includes('contact') && (
          <Contact personal={config.personal} />
        )}
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default App;
